import {
  AvailableAction,
  CashBreakInfo,
  CashBreakSuggestion,
} from './../models/copilot.model'
import { CashBreakService } from './cash-break/cash-break.service'
import { Injectable } from '@angular/core'
import { CashBreakSuggestionsService } from './cash-break/cash-break-suggestions.service'
import { ActionType, MatchCommandData } from '../models/commands.model'
import { CopilotCommandsService } from './commands/copilot-commands.service'

@Injectable({
  providedIn: 'root',
})
export class AvailableActionService {
  constructor(
    private readonly cashBreakService: CashBreakService,
    private readonly cashBreakSuggestionService: CashBreakSuggestionsService,
    private readonly copilotCommandsService: CopilotCommandsService,
  ) {}

  handleAction(action: AvailableAction | undefined) {
    if (!action) {
      return
    }
    switch (action.type) {
      case 'availableSolution':
        window.copilot.close()
        this.cashBreakSuggestionService.openCashBreaksSuggestionsModal(
          action.params.cashBreakSuggestions as CashBreakSuggestion[],
          `${action.params.acctId}`,
          `${action.params.breakId}`,
        )
        break
      case 'filterTransactionsById':
        window.copilot.close()
        this.cashBreakSuggestionService.filterTransactions(
          action.params.cwTranIds as string[],
          action.params.extTranIds as number[],
        )
        break
      case 'acceptSolution':
        this.cashBreakSuggestionService.submitSuggestions(
          action.params.cashBreakSuggestion as CashBreakSuggestion,
          `${action.params.acctId}`,
          `${action.params.breakId}`,
        )
        break
      case 'cashBreakAdvancedSettings':
        window.copilot.close()
        this.cashBreakService
          .openCashBreakAdvancedSettingsModal(
            action.params.cashBreakInfo as CashBreakInfo,
          )
          ?.then(request => {
            if (request)
              this.cashBreakService.createCashBreakSuggestionsWithRequest(
                action.params.cashBreakInfo as CashBreakInfo,
                request,
              )
          })
        break
      case 'command':
        this.handleCommandAction(action)
        break
      case 'showInClarityOpsPanel':
        window.dispatchEvent(
          new CustomEvent('clarity-ops:render-chart', {
            detail: action.params.chart,
          }),
        )
        break
      default:
        console.warn(
          'CopilotActionHandler: unknown action type: ' + action.type,
        )
    }
  }

  handleCommandAction(action: AvailableAction) {
    const accountId = action.params.accountId as number
    const commandType = action.params.commandType as string
    const commandData: MatchCommandData = action.params
      .commandData as MatchCommandData
    const notes: string = action.params.notes as string
    const cwTranIds: string[] = commandData.cwanTranMatchDetails.map(detail => {
      return `${detail.tranId} / ${accountId}`
    })
    const extTranIds: string[] = commandData.extTranMatchDetails.map(detail => {
      return `${detail.extTranId}`
    })
    this.copilotCommandsService
      .createCommands({
        actionType: commandType as ActionType,
        cwTranRowIds: cwTranIds,
        extTranRowIds: extTranIds,
        additionalNotes: notes,
      })
      .subscribe({
        next: () => {
          window.copilot.addAssistantMessage({
            content:
              'Command Creation Successful. Go to the commands drawer to run the account.',
          })
          window.copilot.open()
        },
        error: error => {
          window.copilot.addAssistantMessage({
            content: `Command Creation Failed. Error: ${error.message}`,
          })
          window.copilot.open()
        },
      })
  }
}
